module.exports = __webpack_public_path__ + "img/PL09084.bcfb7b36.png";